<app-landing-page></app-landing-page>
<app-why-me id="why-me"></app-why-me>
<app-my-skills id="my-skills"></app-my-skills>
<app-my-projects id="my-projects"></app-my-projects>
<app-contact-me id="contact-me"></app-contact-me>